import axios from "axios"
import ApiStore from "./ApiStore";
var querystring = require('querystring');


export class AutopartStore extends ApiStore{
  constructor() {
    super();
  }

  loadAutopart(carType,mainNumber,subNumber,completeFunc){
    //console.log('loadSlipInfo',slipId)
    axios.get('/damage/autopart_item/'+carType+'/'+mainNumber+'/'+subNumber)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadPartItem(mainNumber,completeFunc,errorFunc){
    axios.get('/damage/part_item/'+mainNumber+'?format=json')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadWageCategory(completeFunc){
    //console.log('loadSlipInfo',slipId)
    axios.get('/damage/wagecategory')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadWageItemList(categoryId,query,completeFunc){
    let param =''
    if(typeof query!=='undefined' ){
      param = '?query='+query
    }
    axios.get('/damage/wageitemlist/'+categoryId+param)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadDamageItemList(categoryId,query,completeFunc){
    let param =''
    if(typeof query!=='undefined' ){
      param = '?query='+query
    }
    axios.get('/damage/symptomitemlist/'+categoryId+param)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadStockPartCategory(completeFunc){
    axios.get('/stock/genpartcategory')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }


  loadStockPartItemList(categoryId,query,completeFunc){
    let param =''
    if(typeof query!=='undefined' ){
      param = '?query='+query
    }
    axios.get('/stock/genpartitemlist/'+categoryId+param)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadStockPartList(spotNo,groupId,catId,carType,completeFunc,errorFunc){
    axios.get('/damage/stock_part_table/'+spotNo+"/"+groupId+"?cat_id="+catId+"&car_type="+carType+"&format=json")
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadStockPartProductCode(productCode,completeFunc){
    axios.get('/stock/genpartproductcode/?query='+productCode)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadStockProductCode(stockType,productCode,completeFunc,errorFunc){
    axios.get('/stock/'+stockType+'productcode/?query='+productCode)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined)
        errorFunc(error)
    })
  }

  loadStockPartProductCodeList(categoryId,query,completeFunc){
    let param =''
    if(typeof query!=='undefined' ){
      param = '?query='+query
    }
    axios.get('/stock/genpartproductcodelist/'+categoryId+param)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadExPartItemList(categoryId,query,completeFunc){
    let param =''
    if(typeof query!=='undefined' ){
      param = '?query='+query
    }
    axios.get('/stock/expartitemlist/'+categoryId+param)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveWageItemcode(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    let url = '/damage/wageitemcode/'+postData.itemcode
    if(postData.itemcode===''){
      url = '/damage/wageitemcode/-1'
    }
    axios.post(url,querystring.stringify(postData))
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveDamageItemcode(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    let url = '/damage/symptomitem/'+postData.itemcode
    if(postData.itemcode===''){
      url = '/damage/symptomitem'
    }
    axios.post(url,postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveStockPartItemcode(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    let url = '/stock/partitemcode/'+postData.itemcode
    if(postData.itemcode===''){
      url = '/stock/partitemcode/-1'
    }
    axios.post(url,querystring.stringify(postData))
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  savePartItemcode(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    let url = '/damage/partitemcode/'+postData.itemcode
    if(postData.itemcode===''){
      url = '/damage/partitemcode/-1'
    }
    axios.post(url,querystring.stringify(postData))
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveItem(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/damage/newautopartitem',querystring.stringify(postData))
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delWageItemcode(itemcode,completeFunc,errorFunc){
    
    console.log('itemcode',itemcode)
    axios.delete('/damage/wageitemcode/'+itemcode)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delDamageItemcode(itemcode,completeFunc,errorFunc){
    
    console.log('itemcode',itemcode)
    axios.delete('/damage/symptomitem/'+itemcode)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delPartItemcode(itemcode,completeFunc,errorFunc){
    
    console.log('itemcode',itemcode)
    axios.delete('/damage/partitemcode/'+itemcode)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status=='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadStockProductCodeStartWith(stockType,productCode,completeFunc,errorFunc){
    axios.get('/stock/'+stockType+'productcode/?query='+productCode+"&start_with=true")
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      if(errorFunc!==undefined)
        errorFunc(error)
    })
  }
}

export default new AutopartStore()



// WEBPACK FOOTER //
// ./src/stores/AutopartStore.js